import axios from 'axios';
import { computed } from 'vue';
import { useMainStore } from '../stores/mainStore';
import { useSession } from './useSession';

let warmupInFlightPromise: Promise<boolean> | null = null;
let warmedUpSessionId: string | null = null;

export const useAiChatWarmup = () => {
  const { $ld } = useNuxtApp();
  const mainStore = useMainStore();
  const secondaryOrgId = computed(() => String(mainStore.secondaryOrgId ?? ''));
  const { sessionId } = useSession(secondaryOrgId);
  const writableApi = useRuntimeConfig().public.WRITABLE_BASE_API_URL;
  const agenticSearchEnabled = computed(() => ($ld as any)?.flags?.agenticSearch);

  const warmupAiChat = (): Promise<boolean> => {
    if (!agenticSearchEnabled.value) return Promise.resolve(false);
    if (warmedUpSessionId && warmedUpSessionId === sessionId.value) return Promise.resolve(true);
    if (warmupInFlightPromise) return warmupInFlightPromise;
    if (!import.meta.client || !writableApi || !sessionId.value) return Promise.resolve(false);

    const promise = axios
      .post(`${writableApi}api/v6/ai/chat/warmup`, {
        session_id: sessionId.value,
      })
      .then(() => {
        warmedUpSessionId = sessionId.value;
        return true;
      })
      .catch((error: unknown) => {
        const message = error instanceof Error ? error.message : 'Unknown error';
        console.warn('AI chat warmup failed:', message);
        return false;
      })
      .finally(() => {
        warmupInFlightPromise = null;
      });

    warmupInFlightPromise = promise;
    return promise;
  };

  return { warmupAiChat };
};
